import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

export class LessonTypeDto {
  @ApiProperty({ description: 'ID du type de leçon', example: '550e8400-e29b-41d4-a716-446655440000', type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({ description: 'Code du type de leçon', example: 'THEORY', type: 'string' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ description: 'Nom du type de leçon', example: 'Théorie', type: 'string' })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ description: 'Description du type de leçon', example: 'Leçon théorique', type: 'string' })
  @IsOptional()
  @IsString()
  description?: string
}